import React, { useEffect, useState } from 'react';
import { LegacyDeal } from 'src/interfaces/api/Deal';
import { toQueryParamsString } from 'src/utils/ApiUtils';
import HistoryDialog from './HistoryDialog';
import { GetHistoryResponse } from './interfaces/History';
import useAuth from 'src/hooks/api/useAuth';

interface Props {
  dealId: LegacyDeal['id'];
  type: 'commerceInfos' | 'productionInfos' | 'installationInfos';
  open: boolean;
  onClose: () => void;
}

const endpointTypes: Record<Props['type'], string> = {
  commerceInfos: 'commercial-updated-events',
  productionInfos: 'production-updated-events',
  installationInfos: 'installation-updated-events',
};

const HistoryDialogContainer: React.FC<Props> = ({ dealId, type, open, onClose }) => {
  const [error, setError] = useState<string>();
  const [loading, setLoading] = useState(false);
  const [history, setHistory] = useState<GetHistoryResponse>();
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const { fetch } = useAuth();

  const handleLimitChange = (limit: number) => {
    setLimit(limit);
    setPage(0);
  };

  const fetchHistory = (): Promise<any> => {
    return fetch(`/api/deals/${dealId}/${endpointTypes[type]}${toQueryParamsString({ page, limit })}`, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'GET',
    }).then((resp) => {
      if (resp.ok) {
        return resp.json();
      }

      throw new Error("Erreur lors de la récupèration de l'historique");
    });
  };

  useEffect(() => {
    if (open) {
      setLoading(true);

      fetchHistory()
        .then((response) => {
          setHistory(response);
          setLoading(false);
        })
        .catch((error) => {
          setError(error.message);
          setLoading(false);
        });
    }
  }, [open, dealId, type, page, limit]);

  return (
    <HistoryDialog
      history={history}
      page={page}
      limit={limit}
      error={error}
      loading={loading}
      open={open}
      onClose={onClose}
      onLimitChange={handleLimitChange}
      onPageChange={setPage}
    />
  );
};

export default HistoryDialogContainer;
